import React, {useState} from 'react'
import moreOptionSmallIcon from '../../../../_metronic/assets/images/svg/data-room/more-options-small-icon.svg'
import {DataRoomDropdown} from './DataRoomDropdown'
import OutsideClickHandler from 'react-outside-click-handler'
import {DisplayImage} from '../../widgets/components/General/DisplayImage'
import {toast} from 'react-toastify'
import {useIntl} from 'react-intl'
import {editDataRoomsStatus} from '../core/_requests'
import {DateTime} from 'luxon'
import TagManager from 'react-gtm-module'
import {GTMEvent} from '../../../hooks/gtmHelpers'
import {useAuth} from '../../auth'

interface DataRoom {
  dataRoomId: number
  title: string
  subtitle: string
  status: string
  createdAt: string
  updatedAt: string
  companyId: number
  userId: number
  logoId: number
  bannerId: number
  data_Room_Share_Links: DataRoomShareLink[]
  contents: {
    contentId: number
    visits: any[]
    dataroom_content: DataroomContent
  }[]
  user: User
  dataRoomLogo: DataRoomLogo
  sharedWith: any[]
  contentCount: number
  visitsCount: number
}

interface User {
  firstName: string
  lastName: string
  profileImage: number
  file: {
    fileId: number
    name: string
    isProtected: boolean
    module: string
    createdAt: string
    updatedAt: string
    deletedAt: string | null
    companyId: number | null
    userId: number
  }
}

interface DataRoomShareLink {
  id: number
  aclList: string
}
interface DataRoomLogo {
  fileId: number
  name: string
  isProtected: boolean
  module: string
  createdAt: string
  updatedAt: string
  deletedAt: string | null
  companyId: number | null
  userId: number
}

interface DataroomContent {
  dataroom_contentId: number
  isHidden: boolean
  isTrash: boolean
  createdAt: string
  updatedAt: string
  deletedAt: string | null
  dataRoomId: number
  contentId: number
}

interface DataRoomTableProps {
  data: DataRoom
  getAllDataRoomsById: () => void
  setdataRoomId: (dataRoomId: number) => void
}

const DataRoomTableRow = ({data, getAllDataRoomsById, setdataRoomId}: DataRoomTableProps) => {
  const [isChecked, setIsChecked] = useState(data?.status === 'PUBLISHED')
  const [, setdataRoomApiLoading] = useState(true)
  const {formatMessage} = useIntl()
  const [showCloneModal, setCloneShowModal] = useState(false)
  const {currentUser} = useAuth()

  function generateAvatar(email: string, index: number) {
    if (typeof email !== 'string' || email.trim() === '') {
      return null
    }

    const firstLetter = email.trim()[0].toUpperCase()
    const colors = ['#87CEEB', '#98FB98', '#FFD700']

    const avatarStyle = {
      backgroundColor: index < 3 ? colors[index] : colors[index % 3],
    }

    return (
      <div className='rounded-avatar' style={avatarStyle}>
        <span>{firstLetter}</span>
      </div>
    )
  }

  function getTimeDifference(date: any) {
    const minutes = Math.floor(
      date &&
        DateTime.utc().diff(DateTime.fromISO(date), ['days', 'hours', 'minutes']).toObject().minutes
    )

    const days =
      date &&
      DateTime.utc().diff(DateTime.fromISO(date), ['days', 'hours', 'minutes']).toObject().days
    const hours = Math.abs(
      Math.floor(
        date &&
          DateTime.utc().diff(DateTime.fromISO(date), ['days', 'hours', 'minutes']).toObject().hours
      )
    )
    if (days === 0 && hours === 0) {
      return `${minutes} ${formatMessage({id: 'min ago'})}`
    }
    if (days === 0) {
      return `${hours} ${formatMessage({id: 'hrs ago'})}`
    } else if (days === 7) {
      return `${formatMessage({id: '1 week'})}`
    } else if (days < 7) {
      return `${days} ${formatMessage({id: 'days ago'})}`
    } else {
      return DateTime.fromISO(date).toFormat('MMM dd')
    }
  }
  const dataroomvalues = {
    dataRoomId: data.dataRoomId,
    title: data.title,
    subtitle: data.subtitle,
    status: data.status,
    logoId: data.dataRoomLogo?.fileId,
    bannerId: data.bannerId,
  }

  const handleToggleChange = (event: any) => {
    const newCheckedValue = event.target.checked
    setIsChecked(newCheckedValue)
    editDataRoomstatus(newCheckedValue)
  }

  const editDataRoomstatus = async (isChecked: boolean) => {
    if (data?.bannerId === null) {
      data.bannerId = 0
    }
    const updatedDataRoomValues = {
      ...dataroomvalues,
      status: isChecked ? 'PUBLISHED' : 'DRAFT',
    }
    try {
      setdataRoomApiLoading(true)
      if (data?.dataRoomId) {
        const {
          data: {success, errors},
        } = await editDataRoomsStatus(updatedDataRoomValues)
        if (success) {
          toast.success(formatMessage({id: 'Data Room status updated successfully'}))
          getAllDataRoomsById()
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.EditDataRoomStatusSuccessful,
              action: 'normal',
              metadata: {
                dataroom_status: updatedDataRoomValues?.status,
                dataroom_id: data?.dataRoomId,
                title: data?.title,
                subtitle: data?.subtitle,
                logo_id: data?.dataRoomLogo?.fileId,
                banner_id: data?.bannerId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                company_id: currentUser?.companyId,
              },
            },
          })
        } else {
          errors.forEach((error: string) => {
            toast.error(formatMessage({id: error}))
          })
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.EditDataRoomStatusFailed,
              action: 'normal',
              metadata: {
                dataroom_status: updatedDataRoomValues?.status,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                dataroom_id: data?.dataRoomId,
                title: data?.title,
                subtitle: data?.subtitle,
                logo_id: data?.dataRoomLogo?.fileId,
                banner_id: data?.bannerId,
                company_id: currentUser?.companyId,
                error: errors[0],
              },
            },
          })
        }
      }
    } catch (err) {
      console.log(err)
    } finally {
      setdataRoomApiLoading(false)
    }
  }
  const [menuOpen, setMenuOpen] = useState(false)
  const [showDeleteModal, setDeleteShowModal] = useState(false)

  return (
    <>
      <tr>
        <td className='room-space-name dark_text_color'>{data?.title}</td>
        <td className='last-updated dark_text_color'>{getTimeDifference(data?.updatedAt)}</td>
        <td className='room-space-owner'>
          <div className='d-flex align-items-center'>
            <DisplayImage
              imgName={data?.user?.file?.name}
              height='30px'
              width='30px'
              alt='profile'
              fit='contain'
            />
            <p className='mb-0 dark_text_color'>
              {data?.user?.firstName} {data?.user?.lastName}
            </p>
          </div>
        </td>
        <td className='shared-with'>
          <div className='d-flex flex-row align-items-center'>
            <div className='d-flex flex-row align-items-center shared-user-stack'>
              {data?.sharedWith.slice(0, 3).map((email, index) => (
                <div key={index} className='images'>
                  {generateAvatar(email, index)}
                </div>
              ))}
            </div>
            {data?.sharedWith.length > 3 && (
              <p className='mb-0 dark_text_color'>
                {data.sharedWith.length - 3}+ {formatMessage({id: 'more'})}
              </p>
            )}
            {data?.sharedWith.length === 0 && <span className='mb-0'>-</span>}
          </div>
        </td>
        <td className='total-documents dark_text_color'>{data?.contentCount}</td>
        <td className='total-views dark_text_color'>{data?.visitsCount}</td>
        <td className='publish-status'>
          <div className={`status  ${data?.status === 'DRAFT' ? 'not_publish' : ''} `}>
            {data?.status}
          </div>
        </td>
        <td className='Action'>
          <div className='d-flex align-items-center'>
            <label className='toggle' htmlFor={`${data?.dataRoomId}`}>
              <input
                className='toggle__input'
                name=''
                type='checkbox'
                id={`${data?.dataRoomId}`}
                checked={isChecked}
                onChange={handleToggleChange}
              />
              <div className='toggle__fill'></div>
            </label>
            <div className=' card-option-wrapper'>
              <OutsideClickHandler onOutsideClick={() => setMenuOpen(false)}>
                <button
                  type='button'
                  className='btn btn-sm card-option btn-icon btn-color-primary btn-active-light-primary'
                  onClick={() => setMenuOpen(!menuOpen)}
                >
                  <img src={moreOptionSmallIcon} alt=''></img>
                </button>
                <DataRoomDropdown
                  isOpen={menuOpen}
                  dataRoomId={data?.dataRoomId}
                  setDeleteShowModal={setDeleteShowModal}
                  showDeleteModal={showDeleteModal}
                  getAllDataRoomsById={getAllDataRoomsById}
                  setCloneShowModal={setCloneShowModal}
                  showCloneModal={showCloneModal}
                  status={data?.status}
                  setdataRoomId={setdataRoomId}
                />
              </OutsideClickHandler>
            </div>
          </div>
        </td>
      </tr>
    </>
  )
}

export default DataRoomTableRow
